import { createAsyncThunk } from '@reduxjs/toolkit';
import { createRequest } from '../../../helpers/api/createRequest';
import * as usersApi from '../../../api/users';
import { history } from '../../../store/history';
import { routes } from '../../../constants/RouterPath';
import { Thunk } from '../../../helpers/redux/Thunk';

export const DELETE_USER = 'users/deleteUser';

const onSuccess = (): Thunk => () => {
    history.push(routes.users);
};

export const deleteUser = createAsyncThunk(
    DELETE_USER,
    createRequest({
        type: DELETE_USER,
        loader: async (id: number) => usersApi.deleteUser(id),
        onSuccess,
    }),
);
